import { BASE_ENDPOINT } from "../../endpoint";

/**
 * Generates a wallet-funding invoice for a given company and amount.
 * NOTE: This endpoint is documented as a GET with a JSON body, which is
 * unusual — some proxies/clients strip bodies from GET requests. If this
 * call starts silently failing to pass `amount` through, confirm with
 * backend whether it should be a POST instead.
 *
 * @param {string} TOKEN - bearer auth token
 * @param {string|number} companyId
 * @param {number} amount - Naira amount to fund the wallet with
 * @returns {Promise<{invoiceId:number, companyId:number, amount:number, charge:number, payrollPlanName:string, dateInitiated:string, companyName:string, status:string}>}
 */
export const generateInvoice = async (TOKEN, companyId, amount) => {
  try {
    const response = await fetch(
      `${BASE_ENDPOINT}/api/Wallets/${companyId}/generate-invoice`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ amount }),
      },
    );
    const rawText = await response.text();
    let res = {};
    try {
      res = rawText ? JSON.parse(rawText) : {};
    } catch (parseErr) {
      console.error("Non-JSON response body:", rawText);
    }

    if (!response.ok) {
      console.error("Error:", res);
      throw new Error(
        res?.message || `Failed to generate invoice (${response.status})`,
      );
    }
    // Unwrap the shared { status, message, data } envelope here so callers
    // work with the invoice data directly.
    return res?.data;
  } catch (error) {
    console.error("API fetch error:", error);
    throw error;
  }
};
